import { callAPI, callAtlanAPI, getIpInfoAPI, callSearchAPI } from './axios';

//권역 Polygon 데이터 조회 (BoundingBox 영역으로 조회)
export async function getQueryLdongInfoOnMapBySquare(param) {
	//const url = `http://${store.serverIp}/pathplanner/v1/tsp`;
	const url =
		process.env.VUE_APP_TMSURL + '/area/o/query_ldong_info_on_map_by_square';
	return callAPI(url, param);
}

export async function getQueryDriver() {
	const url = process.env.VUE_APP_TMSURL + '/driver/o/query_driver';
	const param = {};
	return callAPI(url, param);
}

export async function reqUpdateDriver(param) {
	const url = process.env.VUE_APP_TMSURL + '/driver/o/update_driver';
	return callAPI(url, param);
}
export async function reqDeleteDriver(param) {
	const url = process.env.VUE_APP_TMSURL + '/driver/o/delete_driver';
	return callAPI(url, param);
}

//기사 등록
export async function reqRegDriver(param) {
	const url = process.env.VUE_APP_TMSURL + '/driver/o/reg_driver';
	return callAPI(url, param);
}

//테스트 기사 등록
export async function reqRegTestDriver(param) {
	const url = process.env.VUE_APP_TMSURL + '/driver/o/reg_test_driver';
	return callAPI(url, param);
}

//테스트 기사 등록 가능여부 조회
export async function isTestDriverCreatePossible() {
	const url =
		process.env.VUE_APP_TMSURL + '/driver/o/is_test_driver_create_possible';
	const param = {};
	return callAPI(url, param);
}

//권역 등록
export async function reqRegTmsArea(param) {
	const url = process.env.VUE_APP_TMSURL + '/area/o/reg_tms_area';
	return callAPI(url, param);
}

//권역 조회
export async function getQueryTmsArea(param) {
	const url = process.env.VUE_APP_TMSURL + '/area/o/query_tms_areas';
	return callAPI(url, param);
}

//권역 삭제
export async function reqDeleteTmsArea(param) {
	const url = process.env.VUE_APP_TMSURL + '/area/o/delete_tms_area';

	return callAPI(url, param);
}

export async function reqUpdateTmsArea(param) {
	const url = process.env.VUE_APP_TMSURL + '/area/o/update_tms_area';

	return callAPI(url, param);
}

export async function getSearchAddress(param) {
	const url = `${process.env.VUE_APP_SEARCH_API_URL}?authKey=${process.env.VUE_APP_APIKEY}&keyword=${param.keyword}
	&curPosX=${param.curPosX}&curPosY=${param.curPosY}&rows=${param.rows}&sort=${param.sort}`;
	return callSearchAPI(url, param);
}

export async function reqQueryAddressList(param) {
	const url = process.env.VUE_APP_TMSURL + '/area/o/query_address_list';

	return callAPI(url, param);
}

export async function reqQueryldongByLcode(param) {
	const url = process.env.VUE_APP_TMSURL + '/area/o/query_ldong_info_by_lcode';

	return callAPI(url, param);
}

export async function reqQueryDashBoard(param) {
	const url = process.env.VUE_APP_TMSURL + '/dashboard/o/query_dashboard';

	return callAPI(url, param);
}

/****** 계정 관리 프로토콜 ******/
//계정 정보 조회
export async function reqQueryMemberInfo(param) {
	const url = process.env.VUE_APP_TMSURL + '/member/o/query_member_info';

	return callAPI(url, param);
}

//비밀번호 유효 확인
export async function reqCheckPassword(param) {
	const url = process.env.VUE_APP_TMSURL + '/member/o/check_password';

	return callAPI(url, param);
}

//비밀번호 변경
export async function reqUpdatePassword(param) {
	const url = process.env.VUE_APP_TMSURL + '/member/o/update_password';

	return callAPI(url, param);
}

//이메일 변경
export async function reqUpdateEmail(param) {
	const url = process.env.VUE_APP_TMSURL + '/member/o/update_email';

	return callAPI(url, param);
}

//회사 주소 변경
export async function reqUpdateAddress(param) {
	const url = process.env.VUE_APP_TMSURL + '/member/o/update_address';

	return callAPI(url, param);
}

//회원 탈퇴
export async function reqMemberDelete(param) {
	const url = process.env.VUE_APP_TMSURL + '/member/o/member_delete';

	return callAPI(url, param);
}

//전화번호로 비밀번호 변경
export async function reqUpdatePasswordByPhoneNum(param) {
	const url =
		process.env.VUE_APP_TMSURL + '/member/x/update_password_by_phone_num';

	return callAtlanAPI(url, param);
}

export async function reqQueryMenuInfo(param) {
	const url = process.env.VUE_APP_TMSURL + '/dashboard/o/query_menu_info';
	return callAPI(url, param);
}

export async function reqReSendMsgDriver(param) {
	const url = process.env.VUE_APP_TMSURL + '/driver/o/re_send_msg_driver';
	return callAPI(url, param);
}

//대쉬보드 - job_id 조회
export async function reqQueryJob(param) {
	const url = process.env.VUE_APP_TMSURL + '/vrp/o/query_job';
	return callAPI(url, param);
}

//공지 사항 조회
export async function reqQueryNotice(param) {
	const url = process.env.VUE_APP_TMSURL + '/notice/o/query_notice';
	return callAPI(url, param);
}

//배송목록에서 선택 - 선택하기 버튼클릭시 job 조회
export async function reqQueryJobFilter(param) {
	const url = process.env.VUE_APP_TMSURL + '/vrp/o/query_job_delivery_task';
	return callAPI(url, param);
}

//고정경로 배송목록에서 선택 - 선택하기 버튼클릭시 job 조회
export async function reqQueryFixJob(param) {
	const url = process.env.VUE_APP_TMSURL + '/vrp/o/query_job';
	return callAPI(url, param);
}
